import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { LineContainerComponent } from "shared-ui-components/lines/lineContainerComponent";
import { TextInputLineComponent } from "shared-ui-components/lines/textInputLineComponent";
import { FramePortPosition } from "shared-ui-components/nodeGraphSystem/graphFrame";
import { IsFramePortData } from "shared-ui-components/nodeGraphSystem/tools";
import { ButtonLineComponent } from "shared-ui-components/lines/buttonLineComponent";
export class FrameNodePortPropertyTabComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            port: this.props.frameNodePort,
        };
        this._onSelectionChangedObserver = this.props.stateManager.onSelectionChangedObservable.add((options) => {
            const { selection } = options || {};
            if (IsFramePortData(selection)) {
                selection.port.onFramePortPositionChangedObservable.clear();
                this._onFramePortPositionChangedObserver = selection.port.onFramePortPositionChangedObservable.add((port) => {
                    this.setState({ port: port });
                });
                this.setState({ port: selection.port });
            }
        });
        this._onFramePortPositionChangedObserver = this.props.frameNodePort.onFramePortPositionChangedObservable.add((port) => {
            this.setState({ port: port });
        });
    }
    componentWillUnmount() {
        this.props.frameNodePort.onFramePortPositionChangedObservable.remove(this._onFramePortPositionChangedObserver);
        this.props.stateManager.onSelectionChangedObservable.remove(this._onSelectionChangedObserver);
    }
    render() {
        return (_jsxs("div", { id: "propertyTab", children: [_jsxs("div", { id: "header", children: [_jsx("img", { id: "logo", src: "https://www.babylonjs.com/Assets/logo-babylonjs-social-twitter.png" }), _jsx("div", { id: "title", children: "NODE MATERIAL EDITOR" })] }), _jsx("div", { children: _jsxs(LineContainerComponent, { title: "GENERAL", children: [_jsx(TextInputLineComponent, { label: "Port Name", lockObject: this.props.stateManager.lockObject, propertyName: "portName", target: this.props.frameNodePort }), this.props.frameNodePort.framePortPosition !== FramePortPosition.Top && (_jsx(ButtonLineComponent, { label: "Move Port Up", onClick: () => {
                                    this.props.frame.moveFramePortUp(this.props.frameNodePort);
                                } })), this.props.frameNodePort.framePortPosition !== FramePortPosition.Bottom && (_jsx(ButtonLineComponent, { label: "Move Port Down", onClick: () => {
                                    this.props.frame.moveFramePortDown(this.props.frameNodePort);
                                } }))] }) })] }));
    }
}
//# sourceMappingURL=frameNodePortPropertyComponent.js.map